/** Hook : redirige vers /auth si non connecté */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function useRequireAuth() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    if (!token) navigate("/auth", { replace: true });
  }, [navigate]);
}

export function getCurrentUser() {
  try {
    const u = sessionStorage.getItem("user");
    return u ? JSON.parse(u) : null;
  } catch {
    return null;
  }
}

export function logout(navigate) {
  sessionStorage.clear();
  navigate("/auth", { replace: true });
}
